import * as types from '../mutation-types'
import subjectService from '../../services/subjects'

const state = {
    loading: false,
    errors: null,
    subjects: []
}

const actions = {
    getAll({ commit }) {
        commit(types.SUBJECT_LOADING, true)
        subjectService.getAll().then(
            response => {

                commit(types.LOAD_SUBJECTS, response.data)
                commit(types.SUBJECT_LOADING, false)
                commit(types.SUBJECT_FAILURE, null)
            },
            error => {
                commit(types.SUBJECT_FAILURE, error)
                commit(types.SUBJECT_LOADING, false)
            }
        )
    },
    add({ commit }, data) {
        commit(types.SUBJECT_LOADING, true)
        commit(types.SUBJECT_FAILURE, null)
        subjectService.add(data).then(
            response => {
                //console.log('responseooo', response)
                data.id = response.data.id
                data.status = 1
                commit(types.ADD_SUBJECT, data)
                commit(types.SUBJECT_LOADING, false)

            },
            error => {
                commit(types.SUBJECT_FAILURE, error)
                commit(types.SUBJECT_LOADING, false)
            }
        )
    },
    update({ commit }, data) {
        commit(types.SUBJECT_LOADING, true)
        commit(types.SUBJECT_FAILURE, null)
        subjectService.update(data.subject)
            .then(
                response => {
                    commit(types.UPDATE_SUBJECT, data)
                    commit(types.SUBJECT_LOADING, false)

                },
                error => {
                    commit(types.SUBJECT_FAILURE, error)
                    commit(types.SUBJECT_LOADING, false)
                }
            )


    },
    delete({ commit }, data) {
        commit(types.SUBJECT_LOADING, true)
        commit(types.SUBJECT_FAILURE, null)
        subjectService.delete(data.subject.id)
            .then(
                response => {

                    commit(types.DELETE_SUBJECT, data)
                    commit(types.SUBJECT_LOADING, false)

                },
                error => {
                    commit(types.SUBJECT_FAILURE, error)
                    commit(types.SUBJECT_LOADING, false)
                }
            )
    }
}

const mutations = {
    [types.ADD_SUBJECT](state, payload) {
        state.subjects.unshift(payload);
    },
    [types.LOAD_SUBJECTS](state, payload) {
        state.subjects = payload
    },
    [types.UPDATE_SUBJECT](state, payload) {
        Object.assign(state.subjects[payload.index], payload.subject);
    },
    [types.DELETE_SUBJECT](state, payload) {
        state.subjects.splice(payload.index, 1)
    },
    [types.SUBJECT_FAILURE](state, payload) {
        state.errors = payload
    },

    [types.SUBJECT_LOADING](state, payload) {
        state.loading = payload
    },
}

const getters = {
    SUBJECTS: state => {
        return state.subjects
    },

    SUBJECT_ERROR: state => {
        return state.errors
    },

    SUBJECT_LOADING: state => {
        return state.loading
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/subjects.js